import React, { FC } from 'react';
import { Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import BareLayout from 'src/layouts/bare/bare.layout';
import { i18nKey } from 'src/locales/i18n';
import styles from './forgot-password-email.module.less';
import emailIcon from 'src/assets/email-blue.svg';
import ShadowBox from 'src/components/shadow-box/shadow-box';

const ForgotPasswordEmail: FC = () => {
	const [t] = useTranslation();
	return (
		<>
			<BareLayout>
				<Row justify="center" gutter={[32, 32]}>
					<Col xs={24} sm={24} md={24} lg={10}>
						<ShadowBox>
							<Col span={24} className={styles.item}>
								<Typography.Title level={3}>{t(i18nKey.login.formCheckEmail.title)}</Typography.Title>
							</Col>
							<Col span={24} className={styles.item}>
								<div>
									<img src={emailIcon} alt="email" />
								</div>
							</Col>
							<Col span={24} className={styles.item}>
								<Typography.Text>{t(i18nKey.login.formCheckEmail.subTitle)}</Typography.Text>
							</Col>
						</ShadowBox>
					</Col>
				</Row>
			</BareLayout>
		</>
	);
};

export default ForgotPasswordEmail;
